import React, { FC } from 'react';
import CompanyDetail, { getServerSideProps as gSSP } from '../../components/pages/CompanyDetail';

const Company: FC<React.PropsWithChildren<unknown>> = () => <CompanyDetail />;

export default Company;

export const getServerSideProps = gSSP;
